// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__32AJS","p":"Menu_p__2ngR-","close":"Menu_close__1AKHb","rotate":"Menu_rotate__2fDJt","logo":"Menu_logo__2Pwv5"};